import { Component, TemplateRef, computed, inject, signal } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';
import { ToastInfo } from '../../models/toast-info';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  imports: [CommonModule],
  standalone: true,
})
export class ToastComponent {
  toastService = inject(ToastService);

  displayToast = signal(false);
  toastInfo = signal<ToastInfo | null>(null);
  opacityClass = signal('opacity-0');

  isString = computed(() => typeof this.toastInfo()?.message === 'string');
  template = computed(() => this.toastInfo()?.message as TemplateRef<string>);

  constructor() {
    this.toastService.getDisplayToastSubject().subscribe(shouldDisplay => {
      if (shouldDisplay) {
        this.toastInfo.set(this.toastService.getToastInfo());
        this.displayToast.set(true);
        this.opacityClass.set('opacity-100');
      } else {
        this.opacityClass.set('opacity-0');
        setTimeout(() => {
          this.displayToast.set(false);
        }, 300);
      }
    });
  }
}
